import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { MbiemriNumri, MbiemriTrajta, MbiemriRasa, MbiemriLloji, MbiemriLlojiTemaShumesit, MbiemriRenditja } from '@core/enums/mbiemri.enums';
import { MbiemriConstants } from '@core/globals/mbiemri-constants';
import { MbiemriFemerorForCreationDTO } from '@core/interfaces/dto/mbiemri-femeror-for-creation-dto.interface';
import { MbiemriBaza } from '@core/interfaces/models/mbiemri-baza.interface';
import { MbiemriFemerorEmerMbiemerFormulaService } from './mbiemri-femeror-emer-mbiemer-formula.service';

@Injectable({
  providedIn: 'root',
})
export class MbiemriFemerorEmerMbiemerService {
  constructor(private mbiemriFemerorEmerMbiemerFormulaService: MbiemriFemerorEmerMbiemerFormulaService, private fb: UntypedFormBuilder) { }

  insertForms(mbiemriBaza: MbiemriBaza, form: UntypedFormGroup) {

    let formArrays = ['mbiemriBaza.mbiemriFemerorEmerMbiemerInitial', 'mbiemriBaza.mbiemriFemerorEmerMbiemer'];
    for (let i = 0; i < formArrays.length; i++) {
      const formArray = form.get(formArrays[i]) as UntypedFormArray;
      this.generateForms(formArray);
      mbiemriBaza.mbiemriFemeror
        ?.filter((r) => r.renditjaId == MbiemriRenditja.EmerMbiemer)
        .forEach((item) => {
          let index = formArray.controls.findIndex(
            (c) =>
              // c.get('gjiniaId')?.value == item.renditjaId &&
              c.get('renditjaId')?.value == item.renditjaId &&
              c.get('numriId')?.value == item.numriId &&
              c.get('trajtaId')?.value == item.trajtaId &&
              c.get('rasaId')?.value == item.rasaId &&
              c.get('formaFjalesId')?.value == item.formaFjalesId &&
              c.get('pershkrimi')?.value == '' &&
              c.get('radhitja')?.value == item.radhitja
          );
          if (index != -1) {
            formArray.controls[index].get('pershkrimi')?.setValue(item.pershkrimi);
          } else {
            this.addNewLakimi(formArray, item.numriId, item.trajtaId, item.rasaId, item.pershkrimi, item.radhitja);
          }
        });
    }
  }

  generateForms(formArray: UntypedFormArray) {
    this.generateMbiemriFemerorForms(formArray);
    this.generateMbiemriFemerorForms(formArray);
  }

  generateFormula(baza: string, mbiemriBaza: MbiemriBaza, form: UntypedFormGroup) {
    let fa = form.get('mbiemriBaza.mbiemriFemerorEmerMbiemer') as UntypedFormArray;
    this.mbiemriFemerorEmerMbiemerFormulaService.generateFormula(baza, mbiemriBaza, fa);
  }

  private generateMbiemriFemerorForms(formArray: UntypedFormArray) {
    while (formArray.length > 0) {
      formArray.removeAt(0);
    }

    for (const mn of MbiemriConstants.MbiemriNumri) {
      for (const mt of MbiemriConstants.MbiemriTrajta) {
        for (const mr of MbiemriConstants.MbiemriRasa) {
          const mbiemriForm = this.fb.group({
            numriId: mn.id,
            trajtaId: mt.id,
            rasaId: mr.id,
            renditjaId: MbiemriRenditja.EmerMbiemer,
            formaFjalesId: null,
            pershkrimi: '',
            radhitja: 1
          });

          formArray.push(mbiemriForm);
        }
      }
    }
  }

  addNewLakimi(formArray: UntypedFormArray, numri: MbiemriNumri, trajta: MbiemriTrajta, rasa: MbiemriRasa, pershkrimi?: string, radhitja?: number) {
    const renditjet = formArray.value.filter((c: any) => c.numriId == numri && c.trajtaId == trajta && c.rasaId == rasa).map((c: any) => c.radhitja);
    const prevIndex = Math.max(...(renditjet.length > 0 ? renditjet : [0]));
    const mbiemriForm = this.fb.group({
      numriId: numri,
      trajtaId: trajta,
      rasaId: rasa,
      renditjaId: MbiemriRenditja.EmerMbiemer,
      formaFjalesId: null,
      pershkrimi: pershkrimi,
      radhitja: radhitja ?? prevIndex + 1
    });
    formArray.push(mbiemriForm);
  }

  getCreationDTO(form: UntypedFormGroup, manual: boolean) {
    const creationDTO: MbiemriFemerorForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('mbiemriBaza.mbiemriFemerorEmerMbiemer') as UntypedFormArray;

    formArray.value.forEach((e: any) => {
      creationDTO.push({
        trajtaId: e.trajtaId,
        numriId: e.numriId,
        rasaId: e.rasaId,
        renditjaId: e.renditjaId,
        formaFjalesId: e.formaFjalesId,
        pershkrimi: e.pershkrimi,
        radhitja: e.radhitja
      });
    });

    return creationDTO;
  }
}
